/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */

/**
 * Carousel types to be used in the frontend
 */
export enum CarouselType {
  SMALL_CIRCLE,
  SQUARE_SMALL,
  SQUARE_LARGE,
  SQUARE_REGULAR,
  SQUARE_REGULAR_WITH_DESCRIPTION,
  ON_GOING,
  HERO,
  BANNER,
}

/**
 * Card width based at 1920px screen
 */
export const BaseCardWidth = {
  [CarouselType.SMALL_CIRCLE]: 180,
  [CarouselType.SQUARE_SMALL]: 180,
  [CarouselType.SQUARE_LARGE]: 390,
  [CarouselType.SQUARE_REGULAR]: 180,
  [CarouselType.ON_GOING]: 600,
  [CarouselType.HERO]: 1800,
  [CarouselType.BANNER]: 1920,
};

/**
 * Carousel sizes coming form the backend
 */
export enum CarouselSize {
  SMALL = 'small',
  REGULAR = 'regular',
  LARGE = 'large',
}

/**
 * Carousel styles coming form the backend
 */
export enum CarouselStyle {
  ROUNDED = 'rounded',
  REGULAR = 'regular',
  ON_GOING = 'ongoing_airing',
  PLAYER_EPISODES = 'player_episodes',
}
